import { Button } from "@material-ui/core";
import { Modal } from "@mui/material";
import {
  ArrowUUpRight,
  CaretRight,
  Check,
  Circle,
  Swap,
  X,
} from "phosphor-react";
import { useState } from "react";
import BreadCrumb from "../../BreadCrumb/BreadCrumb.jsx"; //not added yet!
import StatusDropDown from "../../StatusDropDown/StatusDropDown.component.jsx";
import MoveReviewVersionToShotModal from "../MoveReviewVersionToShotModal.jsx";
import useStyles from "./ReviewVersionViewerTools.styles";

const ReviewVersionViewerTools = ({
  matchWidth,
  onClose,
  updateVersionStatus,
  isExternalReviewer,
  currentStatus,
  setCurrentStatus,
  parentReview,
  selectedVersion,
  showBtn,
  projectId,
  statusList,
  updateRefreshCounter,
}) => {
  const classes = useStyles();
  const [isMoveModalOpen, setIsMoveModalOpen] = useState(false);

  return (
    <div className={classes.toolsContainer}>
      <div
        style={{
          width: matchWidth ? "69%" : "820px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            fontSize: "18px",
          }}
        >
          <BreadCrumb
            fontSize="18px"
            shotCode={parentReview ? parentReview.name : ""}
          />
          <CaretRight />
          <Circle />
          <span>{selectedVersion?.name}</span>
        </div>
      </div>
      <div
        style={{
          width: matchWidth ? "40%" : "520px",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {showBtn && (
          <div className={classes.btnContainer}>
            <Button
              className={classes.toolButton}
              style={{
                backgroundColor: currentStatus === "Revision" ? "#CE7606" : "",
                color: currentStatus === "Revision" ? "#F9F9F9" : "#606479",
              }}
              startIcon={
                <ArrowUUpRight
                  size={16}
                  color={currentStatus === "Revision" ? "#F9F9F9" : "#606479"}
                />
              }
              onClick={() =>
                updateVersionStatus("Revision")
                  .then((data) => setCurrentStatus("Revision"))
                  .catch((error) => console.log(error))
              }
            >
              Under Revision
            </Button>
            <Button
              className={classes.toolButton2}
              style={{
                backgroundColor: currentStatus === "Completed" ? "#6C65D9" : "",
                color: currentStatus === "Completed" ? "#F9F9F9" : "#606479",
              }}
              startIcon={
                <Check
                  size={27}
                  color={currentStatus === "Completed" ? "#F9F9F9" : "#606479"}
                />
              }
              onClick={() =>
                updateVersionStatus("Completed")
                  .then((data) => setCurrentStatus("Completed"))
                  .catch((error) => console.log(error))
              }
            >
              Completed
            </Button>
          </div>
        )}
        <StatusDropDown
          url={`review-version/${selectedVersion?.id}/`}
          statusList={statusList}
          currStatus={{
            id: selectedVersion?.trackable_status,
          }}
          updateRefreshCounter={() =>
            updateRefreshCounter && updateRefreshCounter()
          }
          isReviewVersionStatusUpdate={true}
        />

        <Button onClick={() => setIsMoveModalOpen(true)}>
          <Swap size={22} weight="bold" />
        </Button>
        <Button onClick={onClose}>
          <X size={22} weight="bold" />
        </Button>
      </div>
      <Modal
        open={isMoveModalOpen}
        onClose={() => setIsMoveModalOpen(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <MoveReviewVersionToShotModal
          projectId={projectId}
          selectedVersion={selectedVersion}
          handleClose={() => setIsMoveModalOpen(false)}
          isBulkMove={false}
        />
      </Modal>
    </div>
  );
};

export default ReviewVersionViewerTools;
